import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cef40574&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef40574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cef40574')) {
      api.createRecord('cef40574', component.options)
    } else {
      api.reload('cef40574', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cef40574&scoped=true", function () {
      api.rerender('cef40574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Report/receiveDailyReport/index.vue"
export default component.exports